import { useEffect } from "react";

export default function AuthDiscordCallback() {
  useEffect(() => { window.close(); }, []);
  return null;
}
